/**
 * C 端跟投池，字段与运营端 PortfolioTypes / 领域层模型对齐。
 */
export type FollowPoolOpType = 1 | 2 | 3 | 4 | 5;

export const FOLLOW_POOL_OP_LABEL: Record<FollowPoolOpType, string> = {
  1: "建仓买入",
  2: "加仓买入",
  3: "清仓卖出",
  4: "减仓卖出",
  5: "持仓点评",
};

export interface FollowPoolStockBrief {
  code: string;
  name: string;
  currentPrice?: number;
}

export interface FollowPoolPositionRow {
  code: string;
  name: string;
  buyPriceMax: number;
  currentPrice: number;
  suggestedPositionPct: number;
  buyRangeLow?: number;
  buyRangeHigh?: number;
  buyDate?: string;
}

export interface FollowPoolOperationRow {
  id: string;
  type: FollowPoolOpType;
  createdAt: string;
  interpretation: string;
  stock?: FollowPoolStockBrief;
  priceLow?: number;
  priceHigh?: number;
  suggestedPositionPct?: number;
  sellRatioPct?: number;
  /** 减仓/清仓时池中参考买入价快照（元/股） */
  sellCostPrice?: number;
  /** 折算到组合层面的仓位变动%，= 卖出比例×减仓前池中建议仓位/100 */
  sellPortfolioPct?: number;
}

export interface FollowPoolOperationsPageResult {
  items: FollowPoolOperationRow[];
  hasMore: boolean;
}

export interface FollowPoolOperationsQuery {
  pageSize?: number;
  stockCode?: string;
  cursorBeforeCreatedAt?: string;
  cursorBeforeId?: string;
}
